var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"padless":""}},[_c('v-card',{attrs:{"color":"background","flat":"","tile":"","width":"100%"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('span',[_vm._v(" © 2021 - Telemonial ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }